<div class="pt-4 mb-4 border-b border-[#EAECF0]">
  <div class="flex justify-between items-center pl-6 pb-2">
    <div class="flex items-center">
      <ui-icon name="arrow-narrow-left" class="stroke-[#475467] mr-2 stroke-2 cursor-pointer hover:stroke-[#0F49A0]"
        size="size-4" (click)="onClickBack()" />
      <ui-icon name="canvas" class="stroke-white p-1.5 rounded-[3px] bg-[#77ABF9] mr-2" size="size-4" />
      <div class="ml-2">
        <p class="font-bold text-xl">{{ canvasName || 'Untitled Canvas' }}</p>
        <div class="tooltip-container">
          <p class="text-sm text-[#475467] custom-report-description">
            {{ canvasDescription }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex items-center pr-6">
      <div class="tooltip-container">
        <button
          (click)="addCard()"
          [disabled]="isCanvasLocked() || isMaxCardsReached()"
          [class.disabled]="isCanvasLocked() || isMaxCardsReached()"
          class="flex items-center px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed">
          <ui-icon name="plus" size="size-4" class="stroke-white mr-2"></ui-icon>
          Add Card
        </button>
        @if (isMaxCardsReached()) {
          <div class="tooltip-message">
            Maximum of 5 cards reached
          </div>
        }
      </div>
    </div>
  </div>
</div>

@if (isLoading()) {
  <div class="flex items-center justify-center h-[calc(100vh-100px)]">
    <div class="text-center">
      <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      <p class="mt-2 text-gray-600">Loading canvas...</p>
    </div>
  </div>
}

@if (loadError() && !isLoading()) {
  <div class="flex items-center justify-center h-[calc(100vh-100px)]">
    <div class="text-center">
      <ui-icon name="alert-circle" size="size-8" class="stroke-red-500 mb-3 mx-auto"></ui-icon>
      <p class="text-red-500 text-lg font-medium">Failed to load canvas</p>
      <button (click)="onClickBack()" class="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">
        Return to Canvases
      </button>
    </div>
  </div>
}

@if (!isLoading() && !loadError()) {
  <div class="canvas-main-container">

    <!-- Cards Container -->
    <app-cards-container class="cards-container"
      [isDrawerOpen]="isActionOpen()"
      [isCanvasLocked]="isCanvasLocked()"
      [canvasId]="canvasId"
      (refreshGridster)="refreshGridster()"
      (selectedCardsChange)="onSelectedCardsChange($event)"
      (freeFormCardsChange)="onFreeFormCardsChange($event)"
      (unsavedFreeFormCardsChange)="onUnsavedFreeFormCardsChange($event)"
      (triggerCanvasSave)="onTriggerCanvasSave()"
      (cardRemoved)="onCardRemoved($event)">
    </app-cards-container>

    <!-- Canvas Actions on the right -->
    <app-canvas-actions
      [cards]="cardsContainer ? cardsContainer.cards() : []"
      [canvasId]="canvasId"
      [canvasName]="canvasName"
      [canvasDescription]="canvasDescription"
      [selectedReportIds]="selectedReportIds()"
      [selectedAnswerIds]="selectedAnswerIds()"
      [conversations]="conversations()"
      [getLatestCards]="getLatestCardsForSave.bind(this)"
      [freeFormCards]="freeFormCards()"
      [unsavedFreeFormCards]="unsavedFreeFormCards()"
      (refreshCanvas)="refreshGridster()"
      (actionToggled)="onActionToggled($event)"
      (toggleLockCanvas)="onToggleLockCanvas($event)"
      (afterSaveCanvas)="refreshGridster()"
      (emitConversations)="onConversationsChange($event)"
      (askQuestion)="handleCopilotQuestion($event)">
    </app-canvas-actions>
  </div>
}

<!-- Add Content Modal -->
<app-add-content-modal
  [isOpen]="showAddContentModal()"
  [addedReportIds]="addedReportIds()"
  [addedQuestionIds]="addedQuestionIds()"
  [canvasId]="canvasId"
  (closed)="closeAddContentModal()"
  (addToCanvas)="handleAddToCanvas($event)">
</app-add-content-modal>
